import { useContext } from 'react';
import { BranchContext } from '../context/BranchContext';

/**
 * Hook để sử dụng branch context
 * @returns {Object} Branch context value
 */
export const useBranch = () => {
  const context = useContext(BranchContext);
  if (!context) {
    throw new Error('useBranch must be used within a BranchProvider');
  }
  return context;
};

/**
 * Hook để lấy branch ID đã chọn
 * @returns {string|null} Branch ID
 */
export const useSelectedBranchId = () => {
  const { selectedBranch } = useBranch();
  return selectedBranch?.id || null;
};

/**
 * Hook để lấy thông tin branch đã chọn
 * @returns {Object|null} Branch object
 */
export const useSelectedBranch = () => {
  const { selectedBranch } = useBranch();
  return selectedBranch;
};

/**
 * Hook để kiểm tra branch đã được chọn chưa
 * @returns {boolean} True nếu đã chọn branch
 */
export const useIsBranchSelected = () => {
  const { isBranchSelected } = useBranch();
  return isBranchSelected();
};

/**
 * Hook để lấy danh sách branches
 * @returns {Array} Array of branches
 */
export const useBranches = () => {
  const { branches } = useBranch();
  return branches;
};

/**
 * Hook để chọn branch
 * @returns {Function} Function to select branch
 */
export const useSelectBranch = () => {
  const { selectBranch } = useBranch();
  return selectBranch;
};
